import { Component } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { OpeningTimesOverviewComponent } from '../opening-times-overview/opening-times-overview.component';
import { SpecificOpeningTimesComponent } from '../specific-opening-times/specific-opening-times.component';
import { CurrentOpeningTimesService } from '../current-opening-times.service';

@Component({
  selector: 'app-opening-times-dialog',
  imports: [
    OpeningTimesOverviewComponent,
    SpecificOpeningTimesComponent,
    AsyncPipe,
  ],
  templateUrl: './opening-times-dialog.component.html',
  providers: [CurrentOpeningTimesService],
})
export class OpeningTimesDialogComponent {
  constructor(
    protected currentOpeningTimesService: CurrentOpeningTimesService,
  ) {}
}
